<template>
    <div>
        <div style="border: 1px solid #ccc; margin-top: 10px;">
            <!-- 工具栏 -->
            <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
                    style="height: 250px; overflow-y: hidden;"
                    :defaultConfig="editorConfig"
                    v-model="html"
                    @onChange="onChange"
                    @onCreated="onCreated"
            />
        </div>
    </div>
</template>

<script>
    import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
    import {axios} from "../../config/axios";
    export default {
        name: 'MyEditor',
        components: { Editor, Toolbar },
        props: ['initialContent'],
        data() {
            return {
                editor: null,
                html: this.initialContent,
                toolbarConfig: {
                    // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
                    // excludeKeys: [ /* 隐藏哪些菜单 */ ],
                },
                editorConfig: {
                    placeholder: '请输入内容...',
                    // autoFocus: false,

                    // 所有的菜单配置，都要在 MENU_CONF 属性下
                    MENU_CONF: {
                        uploadImage: { // 注意这里的键是 'uploadImage'
                            server: axios.defaults.baseURL + '/announcements/upload', // 这里填写您的图片上传 API 地址
                            timeout: 5000, // 可选，设置超时时间，单位为毫秒
                            fieldName: 'file', // 可选，后端接收文件的字段名
                            headers: { // 可选，如果需要的话可以设置请求头
                                Authorization: localStorage.getItem("logistics-token"),
                            },
                            maxFileSize: 5 * 1024 * 1024, // 可选，最大文件大小（5MB）
                            onBeforeUpload(file) { // 可选，上传前的回调函数
                                console.log('onBeforeUpload', file);
                                return file;
                            },
                            onSuccess(file, res) { // 可选，上传成功的回调函数
                                console.log('onSuccess', file, res);
                            },
                            onError(file, err, res) { // 可选，上传出错的回调函数
                                console.error('onError', file, err, res);
                            }
                        }
                    }
                }
            }
        },
        watch: {
            'initialContent'(newVal,oldVal){
                this.html = newVal;
                //this.editor.insertHTML(newVal);
            },
        },
        methods: {
            onCreated(editor) {
                this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错

            },
            onChange(editor) {
                // console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
                // 如果需要绑定数据到Vue数据，可以这样操作
                this.$emit('updateContent', this.html);
            },
            insertTextHandler() {
                const editor = this.editor
                if (editor == null) return
                editor.insertText(' hello ')
            },
            printEditorHtml() {
                const editor = this.editor
                if (editor == null) return
                console.log(editor.getHtml())
            },
            disableHandler() {
                const editor = this.editor
                if (editor == null) return
                editor.disable()
            }
        },
        mounted() {

        },
        beforeDestroy() {
            const editor = this.editor
            if (editor == null) return
            editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
        },
    }
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
